// This file is automatically generated with create-ts-svgs script in package.json
import * as React from 'react'; 
			
interface ISvgProps {
	className?: string,
}
			
const fn: React.FunctionComponent<ISvgProps> = (props) => (
	<svg className={props.className} xmlns="http://www.w3.org/2000/svg" viewBox="-1752.9 -3098.9 9.8 9.8"><path className="a" d="M-1747.5-3094l4.4 4.4-.5.5-4.4-4.4-4.4 4.4-.5-.5 4.4-4.4-4.4-4.4.5-.5 4.4 4.4 4.4-4.4.5.5z"/></svg>
);

export default fn;
